import React, { useEffect } from 'react';
import { SalesOrderIcon } from '../../../Assets/Navigation/NavigationIcons';
import { FormLayout } from '../../../Components';
import { CPForm } from '../../../Components/Form';
import { t } from 'i18next';

const AddCustomerPayment = ({ handleToast }) => {
  useEffect(() => {
    document.title = t('Payments.title');
  }, []);

  return (
    <FormLayout
      title={t('Payments.title')}
      Icon={SalesOrderIcon}
      closeUrl="/contacts"
      iconstyle="general_module_icon"
    >
      <CPForm type="add" handleToast={handleToast} />
    </FormLayout>
  );
};

export default AddCustomerPayment;
